module.exports = __webpack_public_path__ + "static/media/demo_1.82bbf03c.mp4";